import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import PdfViewer from "@/shared/components/PDF/PdfViewer";

function ReportViewer() {
  const navigate = useNavigate();
  const location = useLocation();

  const reportUrl: string = location.state.reportUrl;
  const returnTo: string = location.state.returnTo;

  const reportFileUrl = process.env.REACT_APP_ARVAN_S3_BASE_URL + reportUrl;

  function downloadReportPdf() {
    const url = reportFileUrl;
    const link = document.createElement("a");
    link.href = url;
    link.click();
  }

  return (
    <div className="section-container flex flex-col items-center justify-center w-[720px] mx-auto !bg-white">
      <PdfViewer fileUrl={reportFileUrl} />

      <div className="flex flex-col">
        <Button
          className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[20px] right-[100px] max-lg:right-[32px] px-8 text-[18px]  w-[150px]"
          id="download-button"
          onClick={downloadReportPdf}
        >
          <p>دانلود گزارش</p>
        </Button>
        <Button
          className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[65px] right-[100px] max-lg:right-[32px] px-8 text-[18px] w-[150px]"
          id="download-button"
          onClick={() => navigate(returnTo)}
        >
          <p> بازگشت</p>
        </Button>
      </div>
    </div>
  );
}

export default ReportViewer;
